import React, { useCallback, useState } from "react";
import {
  ErrorCustomFetch,
  ErrorCustomUseHookCode,
  fetchCustomPdp,
  TempErrorFrontService,
  TypingEncryptSetting,
} from "../../../../utils/fetchCustomPdp";

//FRAGMENTE ********** TYPING *******************

export type TypingOutPeticionGetQr = {
  msg: string;
  code_qr_url: string;
};

export type TypingOutUseHookBackend = [
  boolean,
  () => Promise<TypingOutPeticionGetQr>
];

export type TypingUseBackend = (url_backend: string) => TypingOutUseHookBackend;

//FRAGMENTE ********** HOOK *******************
const useHookBackendCodeQrPse: TypingUseBackend = (url_backend: string) => {
  const hook_name = "useHookBackendCodeQrPse";
  const [loadingPeticion, setLoadingPeticion] = useState<boolean>(false);

  const PeticionGetQr =
    useCallback(async (): Promise<TypingOutPeticionGetQr> => {
      const function_name = "PeticionGetQr";
      let res_backend;
      const name_service = "Codigo QR PSE";
      setLoadingPeticion(true);
      try {
        const encrypt_setting: TypingEncryptSetting = {
          request_params: true,
          request_body: false,
          response_body: true,
        };
        const params: { [key: string]: any } = {};
        res_backend = await fetchCustomPdp(
          url_backend,
          "GET",
          name_service,
          undefined,
          encrypt_setting,
          params,
          {}
        );
        return {
          msg: res_backend?.msg,
          code_qr_url: res_backend?.obj?.result?.code_qr_url,
        };
      } catch (error: any) {
        if (!(error instanceof ErrorCustomFetch)) {
          throw new ErrorCustomUseHookCode(
            TempErrorFrontService.replace("%s", name_service),
            error.message,
            `${hook_name} - ${function_name}`,
            "notifyError",
            true
          );
        }
        res_backend = error?.res;

        if (res_backend?.obj?.ids?.id_log)
          error.id_any = `Id Log ${res_backend?.obj?.ids?.id_log}`;

        throw error;
      } finally {
        setLoadingPeticion(false);
      }
    }, [url_backend]);
  return [loadingPeticion, PeticionGetQr];
  // as const;
};

export default useHookBackendCodeQrPse;
